































































































































































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import localStorageService from '@/services/LocalStorageService';
import carrierService from '@/services/CarrierService';

import { AccountContract } from '@/models/carriers/AccountContract';
import DropdownOption from '@/models/misc/DropdownOption';
import { ProBlock } from '@/models/carriers/ProBlock';

import PostalCodesInput from './PostalCodesInput.vue';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  components: {
    PostalCodesInput,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      digitCount: 10,
      prefix: '',
      suffix: '',
      format: '',
      zipCodes: [] as string[],
      selectedContracts: [] as AccountContract[],
      priority: { value: 999, text: 'Use 1st' },
      startingRange: null,
      endingRange: null,
      loading: false,
      saving: false,
      snackbar: false,
      snackbarText: '',
      loadingMessage: '',
      all: [] as AccountContract[],
      filteredAccountContracts: [] as AccountContract[],
      page: [] as AccountContract[],
      proBlocks: [] as ProBlock[],
      selectedCarrier: null as DropdownOption,
      contractsHeaders: [
        {
          text: '',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Contract ID',
          value: 'contractId',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
        {
          text: 'Carrier Name',
          value: 'carrierName',
          sortable: false,
        },
        {
          text: 'Contract Description',
          value: 'contractDescription',
          sortable: false,
        },
        {
          text: 'Contract Effective Date',
          value: 'contractEffDate',
          sortable: false,
        },
        {
          text: 'Contract Expiration Date',
          value: 'contractExpDate',
          sortable: false,
        },
      ],
      displayPopup: false,
      refPrefix: 'contract_',
      blockToEdit: null as ProBlock, // in case of edit
      blockContractIds: [] as number[],
      tableKey: 0,
      showSpotContracts: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingMessage = 'Loading details';
      this.loading = true;

      const accountContracts = carrierService
        .getAccountContracts(this.client.id)
        .then((x: AccountContract[]) => {
          this.filteredAccountContracts = x?.filter(
            (x) => !x.contractDescription.includes('Pass Thru')
          );
          this.all = this.filteredAccountContracts;

          if (!this.showSpotContracts) {
            this.filteredAccountContracts =
              this.filteredAccountContracts.filter(
                (x) => !x.contractDescription.includes('Spot')
              );
          }

          this.loading = false;
        });

      const proBlocks = carrierService
        .getProBlocks(this.client.id)
        .then((x: ProBlock[]) => {
          this.proBlocks = x;
        });

      const proBlockContractIds = carrierService
        .getProBlockContractIds(this.client.id, this.blockId)
        .then((x: number[]) => {
          this.blockContractIds = x;
        });

      Promise.all([accountContracts, proBlocks, proBlockContractIds]).then(
        () => {
          if (this.isEdit || this.isCopy) {
            this.setFieldsForEdit();
          }
        }
      );
    },
    setFieldsForEdit() {
      this.blockToEdit = this.proBlocks.find((x) => x.id == this.blockId);
      if (this.blockToEdit) {
        this.selectedCarrier = this.carriersList.find(
          (x) => x.value == this.blockToEdit.carrierId
        );

        this.selectedContracts = this.all.filter((x) =>
          this.blockContractIds.includes(x.contractId)
        );

        this.showSpotContracts = this.all.find((x) =>
          x.contractDescription.includes('Spot')
        );

        this.tableKey += 1;

        this.priority = this.priorityList.find(
          (x) => x.value == this.blockToEdit.priority
        );
        this.startingRange = this.blockToEdit.proMin;
        this.endingRange = this.blockToEdit.proMax;
        this.suffix = this.blockToEdit.suffix;
        this.prefix = this.blockToEdit.prefix;
        this.format = this.blockToEdit.checkFormat;
        this.zipCodes = this.blockToEdit.zipCodes || [];
        this.digitCount = this.blockToEdit.proMax.toString().length;
      }
    },
    onCarrierSelect() {
      this.selectedContracts = [];

      this.filteredAccountContracts.forEach((x) => {
        x.selected = false;
      });

      this.pageChange(1);
    },
    showConfirm() {
      this.displayPopup = true;
    },
    backTo() {
      window.history.back();
    },
    isActiveContract(val, status) {
      return moment(this.formatDate(val)).isAfter(moment()) && status;
    },
    expiredContract(val, status) {
      return moment(this.formatDate(val)).isBefore(moment()) || !status;
    },
    getSelectedImage(item) {
      if (item.text == 'Use 1st') {
        return this.ic_use_1st;
      } else if (item.text == 'Use 2nd') {
        return this.ic_use_2nd;
      } else {
        return this.ic_use_3rd;
      }
    },
    getRefName(id) {
      return this.refNames.find((x) => x.includes(id));
    },
    onContractSelect(contract) {
      const index = this.selectedContracts.findIndex(
        (x) => x.id === contract.id
      );
      if (index > -1) {
        this.selectedContracts.splice(index, 1);
      } else {
        this.selectedContracts.push(contract);
      }
    },
    submitForm() {
      if (!this.formValid) return;

      const request = {};
      request['id'] = null;
      if (this.isEdit) {
        request['id'] = this.blockId;
      }
      request['accountId'] = this.client.id;
      request['carrierId'] = this.selectedCarrier.value;
      request['contractIds'] = this.selectedContracts.map((x) => x.contractId);
      request['prefix'] = this.prefix;
      request['suffix'] = this.suffix;
      request['format'] = this.format;
      request['zipCodes'] = this.zipCodes;
      request['startingRange'] = this.startingRange;
      request['endingRange'] = this.endingRange;
      request['priority'] = this.priority.value;

      this.saving = true;

      carrierService.saveProBlock(request).then((x) => {
        this.saving = false;
        this.displayPopup = false;
        if (!x) {
          this.snackbar = true;
          this.snackbarText = 'Error saving Pro Blocks';
        } else {
          this.snackbar = true;
          this.snackbarText = 'Pro Blocks saved successfully';

          setTimeout(() => {
            this.backTo();
          }, 2500);
        }
      });
    },
    pageChange(newPage) {
      let page = this.carrierContractsToShow.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.page = page;

      this.syncCheckboxes();
    },
    syncCheckboxes() {
      this.page = this.page.map((y) => {
        if (this.selectedContracts.some((x) => x.contractId === y.contractId)) {
          return { ...y, selected: true };
        } else {
          return y;
        }
      });
    },
  },
  computed: {
    refNames() {
      return this.filteredAccountContracts.map(
        (item) => `${this.refPrefix}${item.contractId}`
      );
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    clientsList() {
      return [{ value: this.client?.id, text: this.client?.company }];
    },
    carriersList() {
      return this.filteredAccountContracts.map((x) => {
        return { value: x.carrierId, text: x.carrierName };
      });
    },
    selectedCarrierId() {
      return this.selectedCarrier?.value;
    },
    carrierContractsToShow() {
      return this.filteredAccountContracts.filter(
        (x) => x.carrierId === this.selectedCarrierId
      );
    },
    priorityList() {
      return [
        { value: 999, text: 'Use 1st' },
        { value: 998, text: 'Use 2nd' },
        { value: 997, text: 'Use 3rd' },
        { value: 996, text: 'Use 4th' },
        { value: 995, text: 'Use 5th' },
        { value: 994, text: 'Use 6th' },
        { value: 993, text: 'Use 7th' },
        { value: 992, text: 'Use 8th' },
        { value: 991, text: 'Use 9th' },
        { value: 990, text: 'Use 10th' },
      ];
    },
    totalPros() {
      if (!this.endingRange || !this.startingRange) return 0;

      if (Number(this.endingRange) < Number(this.startingRange)) return 0;

      return Number(this.endingRange) - Number(this.startingRange);
    },
    totalUsedPros() {
      if (!this.isEdit && !this.isCopy) return 0; // new
      if (this.totalPros < this.blockToEdit?.used) return 0;

      return this.blockToEdit?.used >= 0 ? this.blockToEdit?.used : 0;
    },
    remaining() {
      if (this.totalPros < this.totalUsedPros) return 0;

      return this.totalPros - this.totalUsedPros;
    },
    emptyFields() {
      const emptyFields = [];

      if (!this.selectedCarrier) emptyFields.push('Carrier Name');
      if (!this.digitCount || this.digitCount < 3)
        emptyFields.push('Digit Count');
      if (!this.startingRange || this.startingRange < 3)
        emptyFields.push('Pro Number Starting Range');
      if (!this.endingRange || this.endingRange < 3)
        emptyFields.push('Pro Number Ending Range');

      return emptyFields.join(', ');
    },
    contractsNotSelected() {
      return !this.selectedContracts.length;
    },
    proRangeInvalid() {
      return Number(this.startingRange) > Number(this.endingRange);
    },
    formValid() {
      return (
        !this.proRangeInvalid &&
        !this.emptyFields &&
        !this.contractsNotSelected &&
        !this.hasPostalCodeValidationErrors
      );
    },
    isEdit() {
      return this.$route.params.id && window.location.href.includes('edit');
    },
    isCopy() {
      return this.$route.params.id && window.location.href.includes('copy');
    },
    blockId() {
      return this.$route.params.id;
    },
    pageHeader() {
      if (this.isEdit) {
        return 'Update Existing Carrier Pro Number Block';
      }

      if (this.isCopy) {
        return 'Copy Existing Carrier Pro Number Block';
      }

      return 'Create New Carrier Pro Number Block';
    },
    pagingLength() {
      return Math.ceil(this.carrierContractsToShow.length / this.pageSize);
    },
    hasPostalCodeValidationErrors() {
      return (
        this.$refs.postalCodesInput &&
        this.$refs.postalCodesInput.hasValidationErrors
      );
    },
  },
  watch: {
    showSpotContracts(val) {
      if (!val) {
        this.filteredAccountContracts = this.all.filter(
          (x) => !x.contractDescription.includes('Spot')
        );
      } else {
        this.filteredAccountContracts = this.all;
      }

      this.pageChange(1);
    },
  },
});
